// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kVni","questions":"styles_questions__2WNUX","footer":"styles_footer__3eDbq"};